"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PaginationDefaults = {
  page: 1,
  totalCount: null,
  next: null,
  previous: null,
  size: 25
};

var Pagination = /*#__PURE__*/function () {
  function Pagination() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, Pagination);
    Object.assign(this, PaginationDefaults, _objectSpread({}, opts));
  }

  (0, _createClass2["default"])(Pagination, [{
    key: "copy",
    value: function copy() {
      return Pagination.create(this);
    }
  }, {
    key: "update",
    value: function update() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object.assign(this.copy(), data);
    }
  }, {
    key: "calcTotalPages",
    value: function calcTotalPages(pagination) {
      var totalCount = pagination.totalCount,
          size = pagination.size;

      if (!totalCount) {
        return null;
      }

      return Math.ceil(totalCount / size);
    }
  }, {
    key: "setNextPage",
    value: function setNextPage() {
      if (this.page === this.calcTotalPages) return;
      this.page++;
    }
  }, {
    key: "setPrevPage",
    value: function setPrevPage() {
      if (this.page === 1) return;
      this.page--;
    }
  }, {
    key: "hasPrevPage",
    get: function get() {
      return this.page > 1;
    }
  }, {
    key: "hasNextPage",
    get: function get() {
      return this.calcTotalPages(this) && this.page !== this.calcTotalPages(this);
    }
  }, {
    key: "currentPageStart",
    get: function get() {
      return this.page > 1 ? (this.page - 1) * this.size : 1;
    }
  }, {
    key: "currentPageEnd",
    get: function get() {
      return Math.min(this.page > 1 ? this.page * this.size : this.size, this.totalCount);
    }
  }], [{
    key: "create",
    value: function create() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Pagination(opts);
    }
  }]);
  return Pagination;
}();

exports["default"] = Pagination;